import { render, staticRenderFns } from "./releaseAnnouncement.vue?vue&type=template&id=223f7710&scoped=true&"
import script from "./releaseAnnouncement.vue?vue&type=script&lang=js&"
export * from "./releaseAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./releaseAnnouncement.vue?vue&type=style&index=0&id=223f7710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223f7710",
  null
  
)

export default component.exports